import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  class: "sec-main newsD-main pb-0"
}
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "col-sm-10 mx-auto list-content" }
const _hoisted_12 = {
  key: 0,
  class: "list-banner"
}
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "board bg-white" }
const _hoisted_15 = { class: "head-row flex-grow-1 text-primary" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "活動介紹", -1)
const _hoisted_18 = { class: "pre-text" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "活動日期", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "活動地點", -1)
const _hoisted_21 = { class: "pre-text" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "費用性質", -1)
const _hoisted_23 = { class: "pre-text" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "主辦單位", -1)
const _hoisted_25 = { class: "pre-text" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "聯絡資訊", -1)
const _hoisted_27 = { class: "pre-text" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "網址", -1)
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "frce mt-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "返回前頁", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ol", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/",
                      title: "首頁"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("首頁")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/startupHub?tab=events",
                      title: "社創基地"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("社創基地")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.item.name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.item.file2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: _ctx.item.file2.path,
                        class: "img-fluid",
                        alt: _ctx.item.file2.name
                      }, null, 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.item.name), 1),
                  _hoisted_16,
                  (_ctx.item.description)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_17,
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.item.description), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.item.date)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_19,
                        _createElementVNode("p", null, _toDisplayString(_ctx.item.date + (_ctx.item.time ? ' ' + _ctx.item.time : '')), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.item.location)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_20,
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.item.location), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.item.expenditure)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _hoisted_22,
                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.item.expenditure), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.item.organizer)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _hoisted_24,
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.item.organizer), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.item.contact)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _hoisted_26,
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.item.contact), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.item.url)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _hoisted_28,
                        _createElementVNode("a", {
                          class: "link",
                          href: _ctx.item.url,
                          title: "另開新視窗",
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(_ctx.item.url), 9, _hoisted_29)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_router_link, {
                    to: "/startupHub?tab=events",
                    class: "btn-anchor back",
                    "aria-label": "返回前頁"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}